import React from 'react';
import './App.css';
import MainLayout from './components/main';

const App: React.FC = () => {

  return (
    <MainLayout />
  );
};

export default App;
